export default __webpack_public_path__ + "static/media/celo-apes.6d3941f2.jpg";